module.exports = __webpack_public_path__ + "img/cont-08-crescita.f26ff6e5.svg";